import React, {FC} from 'react';
import DocumentRequest from './DocumentRequest';

const InvoiceRequest: FC = () => (
  <DocumentRequest humanNamePlural="Factures" feminine={true} />
);

export default InvoiceRequest;
